// @ts-check
// Operações dos webhooks de saída na tela (contrato 08 da API): registros (<objeto>.<ação>) e metadados
// (metadata.<objectMetadata|fieldMetadata|*>.<ação> e metadata.*), como no Twenty.

/**
 * "person.created" -> { objectName: 'person', action: 'created' }; "metadata.fieldMetadata.created" -> objeto
 * "metadata.fieldMetadata"; "metadata.*" (todos os metadados) -> objeto "metadata.*", ação "*".
 * @param {string} operation
 */
export function splitWebhookOperation(operation) {
  if (operation === 'metadata.*' || operation === 'metadata.*.*') return { objectName: 'metadata.*', action: '*' };
  const separator = operation.lastIndexOf('.');
  return { objectName: operation.slice(0, separator), action: operation.slice(separator + 1) };
}

/** @param {{ objectName: string, action: string }} operation */
export function joinWebhookOperation({ objectName, action }) {
  return objectName === 'metadata.*' ? (action === '*' ? 'metadata.*' : `metadata.*.${action}`) : `${objectName}.${action}`;
}
